// index_tracking_links_page.js - CoHost Tracking Links Index Page

// Import shared validation logic
import { validate_link } from '../prefix_tracking_links/link_validations';
import { storeDistributionUpdateFlash } from '../shared/distribution_update_feedback';

// Global constants
const LINK_NAME_REGEX = /^[a-zA-Z0-9 _\-$&''\u2018\u2019().,;:!?\u2013\u2014]+$/;

document.addEventListener('alpine:init', () => {
    // Main Alpine.js data function for tracking link library
    Alpine.data('tracking_link_index_app_library_data', () => {
        // Get all data from the template tag
        const template = document.getElementById('app-tracking-links-index-data');
        const authenticity_token = template.dataset.authenticityToken;
        const duplicate_url_template = template.dataset.duplicateUrl;
        const delete_url_base = template.dataset.deleteUrl;
        const show_id = template.dataset.showId;
        
        return {
            // Duplicate tracking link modal state
            all_source_data: [],
            show_duplicate_modal: false,
            link_name: '',
            selected_source: '',
            tracking_source_id: '',
            selected_tracking_source_id: '',
            selected_tracking_link_source_name: '',
            tracking_link_id: '',
            has_source_error: false,
            source_error_message: '',
            has_link_name_error: false,
            link_name_error_message: '',
            create_button_text: 'Create Link',
            
            // Delete tracking link modal state
            show_delete_modal: false,
            delete_text: "",
            delete_button_text: "Delete Link",
            
            // Menu state
            open_menus: {}, // Track which menus are open by tracking link ID
            
            // Constants
            MAX_LINK_NAME_LENGTH: 30,
            MIN_LINK_NAME_LENGTH: 2,
            
            init() {

                this.duplicate_tracking_link_init();
            },
            
            // Initialize duplicate tracking link functionality
            duplicate_tracking_link_init() {

                let that = this;
                const source_list = that.$refs.frontend_data.dataset.sourceList;
                that.all_source_data = JSON.parse(source_list);

            },
            
            // Menu Management
            toggle_menu(tracking_link_id) {

                // Close all other menus first
                Object.keys(this.open_menus).forEach(id => {
                    if (id !== tracking_link_id) {
                        this.open_menus[id] = false;
                    }
                });
                
                // Toggle the current menu
                this.open_menus[tracking_link_id] = !this.open_menus[tracking_link_id];

            },
            
            close_menu(tracking_link_id) {

                this.open_menus[tracking_link_id] = false;
            },
            
            close_all_menus() {

                Object.keys(this.open_menus).forEach(id => {
                    this.open_menus[id] = false;
                });
            },
            
            // Duplicate Tracking Link Modal
            open_duplicate_tracking_link_modal(tracking_link_id, source_id) {
                this.show_duplicate_modal = true;
                this.tracking_link_id = tracking_link_id;
                this.tracking_source_id = source_id;
            },
            
            close_duplicate_tracking_link_modal() {

                this.show_duplicate_modal = false;
                this.tracking_link_id = '';
                this.selected_source = '';
                this.tracking_source_id = '';
                this.selected_source_id = '';
                this.selected_tracking_source_id = '';
                this.has_source_error = false;
                this.source_error_message = '';
                this.has_link_name_error = false;
                this.link_name_error_message = '';
                this.link_name = '';
                this.create_button_text = 'Create Link';
            },
            
            validate_submit_duplicate_link() {

                this.has_source_error = false;
                this.source_error_message = '';
                this.has_link_name_error = false;
                this.link_name_error_message = '';
                
                // Validate source selection
                if (this.selected_tracking_source_id === '') {

                    this.has_source_error = true;
                    this.source_error_message = 'Please select a source';
                }
                
                // Validate link name
                if (this.link_name.trim() === '') {

                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Please enter a link name';
                }
                
                if (this.link_name.length > this.MAX_LINK_NAME_LENGTH) {

                    this.has_link_name_error = true;
                    this.link_name_error_message = `Link name should be less than ${this.MAX_LINK_NAME_LENGTH} characters`;
                }
                
                if (this.link_name.length > 0 && this.link_name.length <= this.MIN_LINK_NAME_LENGTH) {

                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name should have more than 2 characters';
                }
                
                // Check if source is different
                if (this.selected_tracking_source_id === this.tracking_source_id) {

                    this.has_source_error = true;
                    this.source_error_message = 'Please select a different source than the link you are duplicating.';
                }
                
                // Validate link name characters
                if (!LINK_NAME_REGEX.test(this.link_name)) {

                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name contains unsupported characters.';
                }
                
                if (this.has_source_error || this.has_link_name_error) {

                    return false;
                } else {

                    this.submit_duplicate_link_data();
                }
            },
            
            submit_duplicate_link_data() {

                let that = this;
                that.create_button_text = 'Creating Link...';
                
                // Construct duplicate URL by replacing placeholder
                let duplicate_link_url = duplicate_url_template.replace(':replace_id', this.tracking_link_id);
                const tracking_link_source_name = this.all_source_data.find(
                    source => source.id === this.selected_tracking_source_id
                ).source;
                
                fetch(duplicate_link_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: authenticity_token,
                        tracking_link_id: this.tracking_link_id,
                        tracking_source_id: this.selected_tracking_source_id,
                        tracking_link_source_name: tracking_link_source_name,
                        link_name: this.link_name
                    })
                }).then(function (res) {

                    setTimeout(function () {
                        sessionStorage.setItem('flash_message', JSON.stringify(['notice', 'Your tracking link(s) have been created!']));

                        document.location.href = delete_url_base;
                    }, 250);
                }).catch(function (error) {

                    alert("There was an error creating the link. Please try again.");
                    that.create_button_text = 'Error, try again';
                    setTimeout(function () {
                        that.create_button_text = 'Create Link';
                    }, 2000);
                });
            },
            
            // Delete Tracking Link Modal
            open_delete_modal(id, link_name) {

                this.delete_text = `You are deleting the link ${link_name}.`;
                this.show_delete_modal = true;
                // Close the menu when opening delete modal
                this.open_menus[id] = false;
                this.tracking_link_id = id;
            },
            
            delete_tracking_link() {

                let that = this;
                that.delete_button_text = "Deleting Link...";
                
                // Construct delete URL
                const delete_url = `${delete_url_base}/${this.tracking_link_id}`;

                
                fetch(delete_url, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: authenticity_token
                    })
                }).then(function (res) {

                    setTimeout(function () {

                        document.location.href = delete_url_base;
                    }, 250);
                    that.delete_button_text = "Delete Link";
                }).catch(function (error) {

                    alert("There was an error deleting the link. Please try again.");
                    that.delete_button_text = "Error, try again";
                    setTimeout(function () {
                        that.delete_button_text = "Delete Link";
                    }, 2000);
                });
            }
        };
    });
    
    // First-time setup flow component
    Alpine.data('linkComponentSetup', () => {
        // Get data from the template tag for first-time setup
        const setupTemplate = document.getElementById('app-tracking-links-setup-data');
        const distribution_links = JSON.parse(setupTemplate.dataset.distributionLinks);
        const all_distribution_platforms = JSON.parse(setupTemplate.dataset.allDistributionPlatforms);
        const batch_update_url = setupTemplate.dataset.batchUpdateUrl;
        const continue_url = setupTemplate.dataset.continueUrl;
        const authenticity_token = setupTemplate.dataset.authenticityToken;
        
        return {
            distribution_links: distribution_links,
            all_distribution_platforms: all_distribution_platforms,
            distribution_links_truth: [],
            add_more_options: [],
            selected_youtube_url: false, // Responsible for the note that shows up when youtube videos are selected
            linkSelector: null,
            selectorVisible: false,
            distributionLinkSelector: undefined,
            existing_links_to_delete: [],
            error_text: "",
            
            init() {

                this.linkSelector = document.querySelector("#link-selector");
                this.create_arrays();
                let that = this;
                // Listen for changes to the array and update selected_youtube_url
                this.$watch('distribution_links_truth', (newValue) => {
                    that.selected_youtube_url = newValue.some(link => link.pattern === 'youtube_url');
                });
            },
            
            create_arrays() {

                let that = this;
                for (let i = 0; i < that.all_distribution_platforms.length; i++) {
                    if (that.distribution_links.hasOwnProperty(that.all_distribution_platforms[i].pattern) && 
                        that.distribution_links[that.all_distribution_platforms[i].pattern] !== "") {

                        that.distribution_links_truth.push({
                            name: that.all_distribution_platforms[i].name,
                            pattern: that.all_distribution_platforms[i].pattern,
                            url: that.distribution_links[that.all_distribution_platforms[i].pattern]
                        });
                    } else {

                        that.add_more_options.push({
                            name: that.all_distribution_platforms[i].name,
                            pattern: that.all_distribution_platforms[i].pattern
                        });
                    }
                }
                
                this.build_options_list();
                if (this.distribution_links_truth.length > 0) {
                    this.create_link_elements();
                } else {
                    this.create_empty_link_elements();
                }
            },
            
            create_link_elements() {

                const linksContainer = document.querySelector("#links-container");
                for (let i = 0; i < this.distribution_links_truth.length; i++) {
                    const link = this.distribution_links_truth[i];
                    if (link.url !== "") {
                        if (link.name === "Custom") {
                            linksContainer.innerHTML += `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="flex space-x-2 w-full">
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${link.pattern}-title" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Enter the name to be displayed" value="${link.title}">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' && validate_link('${link.pattern}', $event.target.value, false) === true ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${link.pattern}-url" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Copy and paste your custom link" value="${link.url}">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                        </div>

                        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;
                        } else {
                            linksContainer.innerHTML += `
                        <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                          <div class="flex space-x-4 items-center">
                            <div class="w-12 h-12">
                              <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                            </div>
                            <div class="flex flex-col flex-1 space-y-2">
                              <div class="font-bold text-sm">${link.name}</div>
                              <div class="flex space-x-2 items-center">
                                <div class="relative rounded-md shadow-sm w-full"
                                          x-data="{ url: '${link.url}', is_valid: validate_link('${link.pattern}', '${link.url}', false) }"
                                          x-init="$watch('url', value => {
                                              if (value === '') {
                                                is_valid = null
                                              } else {
                                                is_valid = validate_link('${link.pattern}', value, false)
                                              }
                                          })"
                                >
                                    <input
                                    x-model="url"
                                    id="${link.pattern}-url"
                                    autocomplete="off"
                                    type="text"
                                    class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                                    placeholder="Copy and paste your ${link.name} show link" value="${link.url}">
                                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                      </svg>
                                    </div>
                                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    x-show="is_valid === false">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                                        <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      `;
                        }
                    }
                }
            },
            
            create_empty_link_elements() {

                let that = this;
                const linksContainer = document.querySelector("#links-container");
                const default_items = [
                    {name: "Apple Podcasts", pattern: "itunes_url", url: ""}, 
                    {name: "Spotify", pattern: "spotify_url", url: ""}, 
                    {name: "YouTube Music", pattern: "youtube_music_url", url: ""}
                ];
                
                for (let i = 0; i < default_items.length; i++) {
                    const link = default_items[i];
                    that.distribution_links_truth.push({
                        name: link.name,
                        pattern: link.pattern,
                        url: ""
                    });
                    linksContainer.innerHTML += `
<div id="${link.pattern}" class="border rounded p-4 ql-link-el">
  <div class="flex space-x-4 items-center">
    <div class="w-12 h-12">
      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
    </div>
    <div class="flex flex-col flex-1 space-y-2">
      <div class="font-bold text-sm">${link.name}</div>
      <div class="flex space-x-2 items-center">
        <div class="relative rounded-md shadow-sm w-full"
             x-data="{ url: '', is_valid: null }"
             x-init="$watch('url', value => {
               is_valid = value === '' ? null : validate_link('${link.pattern}', value, false)
             })">
          <input
            x-model="url"
            id="${link.pattern}-url"
            autocomplete="off"
            type="text"
            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
            placeholder="Copy and paste your ${link.name} show link"
          >

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === true">
                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                      </svg>
          </div>

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === false">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')"
             width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z"
                stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</div>
`;
                    that.remove_from_options_list(link.pattern);
                }
            },
            
            delete_link(name, pattern) {

                this.clear_error_message();
                document.querySelector(`#${pattern}`).remove();
                
                for (let i = 0; i < this.distribution_links_truth.length; i++) {
                    if (this.distribution_links_truth[i].pattern === pattern) {
                        this.distribution_links_truth.splice(i, 1);
                    }
                }
                
                if (this.distribution_links.hasOwnProperty(pattern) && 
                    !this.existing_links_to_delete.includes(pattern)) {
                    this.existing_links_to_delete.push(pattern);
                }
                
                this.add_to_options_list(name, pattern);
            },
            
            add_to_options_list(name, pattern) {

                this.add_more_options.push({
                    name: name,
                    pattern: pattern
                });
                this.build_options_list();
            },
            
            remove_from_options_list(pattern) {

                for (let i = 0; i < this.add_more_options.length; i++) {
                    if (this.add_more_options[i].pattern === pattern) {
                        this.add_more_options.splice(i, 1);
                    }
                }
                this.build_options_list();
            },
            
            build_options_list() {

                const linkSelector = document.querySelector("#link-selector");
                linkSelector.innerHTML = `<option value="">Select a listening app</option>`;
                for (let i = 0; i < this.add_more_options.length; i++) {
                    const option = this.add_more_options[i];
                    linkSelector.innerHTML += `<option value="${option.pattern}">${option.name}</option>`;
                }
                this.sync_options();
            },
            
            handle_add_more() {

                const linkElements = document.querySelectorAll(".ql-link-el");
                for (let i = 0; i < linkElements.length; i++) {
                    const linkElement = linkElements[i];
                    const pattern = linkElement.id;
                    const url = document.querySelector(`#${pattern}-url`).value;
                    if (this.validate_link(pattern, url, true) === false) {

                        alert('Please fix the issues with the links before adding more.');
                        return;
                    }
                }
                
                const linkSelector = document.querySelector("#link-selector");
                let that = this;
                
                const handleItemAdd = function (value, item) {

                    that.distributionLinkSelector.clear();
                    that.distributionLinkSelector.destroy();
                    that.selectorVisible = false;
                    linkSelector.classList.add("hidden");
                    that.create_link_element(value, item);
                };

                const handleBlur = function () {

                    that.distributionLinkSelector.clear();
                    that.distributionLinkSelector.destroy();
                    that.selectorVisible = false;
                    linkSelector.classList.add("hidden");
                };
                
                linkSelector.classList.remove("hidden");
                that.distributionLinkSelector = new TomSelect("#link-selector", {
                    create: false
                });
                that.selectorVisible = true;
                that.distributionLinkSelector.on("item_add", handleItemAdd);
                that.distributionLinkSelector.on("blur", handleBlur);
            },
            
            sync_options() {
                if (this.selectorVisible) {
                    this.distributionLinkSelector.sync();
                }
            },
            
            create_link_element(value, item) {

                const linksContainer = document.querySelector("#links-container");
                const newDiv = document.createElement("div");
                linksContainer.appendChild(newDiv);
                
                if (item.textContent === "Custom") {
                    newDiv.outerHTML = `
                <div id="${value}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${value}_image.svg" alt="${item.textContent} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${item.textContent}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="flex space-x-2 w-full">
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${value}-title" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Enter the name to be displayed" value="">
                                <div class="hidden absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' && validate_link('${value}', $event.target.value, false) === true ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${value}-url" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Copy and paste your custom link" value="">
                                <div class="hidden absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                        </div>

                        <svg class="cursor-pointer" @click="delete_link('${item.textContent}','${value}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;
                } else {
                    newDiv.outerHTML = `
<div id="${value}" class="border rounded p-4 ql-link-el">
  <div class="flex space-x-4 items-center">
    <div class="w-12 h-12">
      <img src="https://files.cohostpodcasting.com/static/${value}_image.svg" alt="${item.textContent} Logo">
    </div>
    <div class="flex flex-col flex-1 space-y-2">
      <div class="font-bold text-sm">${item.textContent}</div>
      <div class="flex space-x-2 items-center">
        <div class="relative rounded-md shadow-sm w-full"
             x-data="{ url: '', is_valid: null }"
             x-init="$watch('url', value => {
               is_valid = value === '' ? null : validate_link('${value}', value, false)
             })">
          <input
            x-model="url"
            id="${value}-url"
            type="text"
            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
            placeholder="Copy and paste your ${item.textContent} show link"
          >

<div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                      </svg>
                                    </div>

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === false">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <svg class="cursor-pointer" @click="delete_link('${item.textContent}','${value}')"
             width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z"
                stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</div>
`;
                }
                
                this.remove_from_options_list(value);
                this.distribution_links_truth.push({
                    name: item.textContent,
                    pattern: value,
                    url: ""
                });
            },
            
            submit() {

                const linkElements = document.querySelectorAll(".ql-link-el");
                let data = {};
                
                for (let i = 0; i < linkElements.length; i++) {
                    const linkElement = linkElements[i];
                    const pattern = linkElement.id;
                    const url = document.querySelector(`#${pattern}-url`).value;
                    data[pattern] = url;
                    
                    if (this.validate_link(pattern, url, true) === false) {

                        alert('Please fix the issues with the links before submitting.');
                        return;
                    }
                }
                
                if (Object.keys(data).length === 0 || this.check_if_all_empty(data)) {

                    this.error_text = "Please enter at least one show link.";
                } else {
                    for (let i = 0; i < this.existing_links_to_delete.length; i++) {
                        if (data.hasOwnProperty(this.existing_links_to_delete[i]) === false) {
                            data[this.existing_links_to_delete[i]] = "";
                        }
                    }
                    


                    
                    fetch(batch_update_url, {
                        headers: {
                            "Content-Type": "application/json"
                        },
                        method: "POST",
                        body: JSON.stringify({
                            authenticity_token: authenticity_token,
                            distribution_links: data
                        })
                    }).then(response => Promise.all([Promise.resolve(response.ok), response.json()]))
                        .then(([ok, data]) => {
                            if (!ok) {
                                throw data;
                            }

                            storeDistributionUpdateFlash(data, 'Your tracking link(s) have been created!');
                            window.location.href = continue_url;
                        })
                        .catch(error => {

                        });
                }
            },
            
            check_if_all_empty(obj) {
                let allEmpty = true;
                for (let key in obj) {
                    if (obj[key] !== "") {
                        allEmpty = false;
                    }
                }
                return allEmpty;
            },
            
            validate_link(pattern, url, set_message) {
                // Use the imported validation function
                const result = validate_link(pattern, url);
                
                // Set error message if validation fails and set_message is true
                if (!result && set_message) {
                    this.set_error_message(pattern);
                }
                
                return result;
            },
            
            set_error_message(pattern) {
                for (let i = 0; i < this.all_distribution_platforms.length; i++) {
                    const item = this.all_distribution_platforms[i];
                    if (item.pattern === pattern) {
                        this.error_text = `Please enter a valid ${item.name} link.`;
                    }
                }
            },
            
            clear_error_message() {
                this.error_text = "";
            }
        };
    });
});

// Copy to clipboard functionality - Global window function
window.copyToClipboard = function (text) {
    // Generate a random 4-digit number for cache busting
    const randomVersion = Math.floor(1000 + Math.random() * 9000);
    const urlWithVersion = text + '&v=' + randomVersion;
    


    const notification = document.querySelector("#copied-to-clipboard-notification");
    
    if (navigator.clipboard && window.isSecureContext) {
        // Modern clipboard API
        navigator.clipboard.writeText(urlWithVersion).then(function () {

            notification.classList.remove("hidden");
            setTimeout(function () {
                notification.classList.add("hidden");
            }, 3000);
        }, function (err) {

        });
    } else {
        // Fallback for insecure contexts

        const textarea = document.createElement("textarea");
        textarea.value = urlWithVersion;
        textarea.style.position = "fixed";
        textarea.style.top = "-1000px";
        textarea.style.left = "-1000px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        
        try {
            document.execCommand('copy');

            notification.classList.remove("hidden");
            setTimeout(function () {
                notification.classList.add("hidden");
            }, 3000);
        } catch (err) {

        }
        
        document.body.removeChild(textarea);
    }
};
